import { createPlugin } from 'leva/plugin'
import { Elastic } from './Elastic'
import { normalize, sanitize } from '../utilities/spring-plugin'

export const elastic = createPlugin({
  normalize,
  sanitize,
  component: Elastic,
})